import {makeReactContext} from 'lib/makeReactContext';
import {HandleInfo} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/flowchartIdentifierUtils';

export interface HandlesContextValue {
  handlesInUse: Array<string>;
  connectionDragState: {
    isDragging: boolean;
    sourceHandleInfo?: HandleInfo;
  } | null;
}

/** Context to keep track of which handles are currently connected via at least one edge */
export const HandlesContext = makeReactContext<HandlesContextValue>(
  () => ({
    handlesInUse: [],
    connectionDragState: null,
  }),
  'HandlesContext'
);
